import { twMerge } from 'tailwind-merge'
import { ISection } from '../../../models/ISection'
import Post from '../../components/Post'
import Link from 'next/link';
import SectionTitle from '../../components/SectionTitle';

export default function SectionTwo(data: ISection) {
  if (!data?.posts?.length) return null;
  const post1 = data.posts[0];
  const post2 = data.posts[1];
  const post3 = data.posts[2];
  const post4 = data.posts[3];
  const post5 = data.posts[4];
  return (
      <section key={data.internalName} className='overflow-x-hidden'>
      {data.showTitle && data.title ? <SectionTitle title={data.title} href={`/${data.targetSlug}`} target='_self'/> : null}

       <div className='grid grid-cols-1 tablet:grid-cols-4 tablet:grid-rows-[3fr_1fr] desktop:grid-rows-2 gap-[24px] h-fit'>
          <Post 
          isLarge
             badge={{mobile: 'image', tablet: 'image', desktop: 'image'}}
          newsType={post1.newsType}
            targetSlug={data.targetSlug} 
            automated={data.automated} 
            targetType={data.targetType} 
            type={post1.type} 
            title={post1.title}
            image={{
              src: post1.imageUrls.url, 
              fill: true, 
              sizes: '100vw', 
              className: 'aspect-[4/3] rounded-tr-[12px] rounded-tl-[12px] tablet:aspect-[636/575]',
              alt: post1.imageAlt || '', 
              ...(data.eager ? {priority: true, loading: 'eager'} : {})
            }} 
            category={post1.category} 
            uniqueCode={post1.uniqueCode}
            hide={{category: true}}
            classNames={{
              wrapper: twMerge(
                'flex-1 rounded-[12px] tablet:col-start-1 tablet:col-end-3 tablet:row-start-1 tablet:row-end-3 desktop:h-full',  
              ),
              image: twMerge('mb-0 desktop:block'), 
              contentContainer: 'p-[16px] flex-1', 
              title: twMerge('h3 line-clamp-2'), 
            }}
            thumbnail={post1.imageUrls.thumbUrl}
          />
            <Post 
               badge={{mobile: 'image', tablet: 'image', desktop: 'image'}}
            newsType={post2.newsType}
            targetSlug={data.targetSlug} 
            automated={data.automated} 
            targetType={data.targetType} 
            type={post2.type} 
            title={post2.title}
            image={{
              src: post2.imageUrls.url, 
              fill: true, 
              sizes: '100vw', 
              className: 'rounded-[12px] rounded-tl-[12px] rounded-tr-[12px] tablet:rounded-b-none aspect-[3/4] desktop:aspect-[4/3]',
              alt: post2.imageAlt || '', 
            }} 
            category={post2.category} 
            uniqueCode={post2.uniqueCode}
            hide={{category: true}}
            classNames={{
              wrapper: twMerge(
                'flex-1 flex-row tablet:flex-col rounded-[12px] tablet:col-start-3 tablet:col-end-4 tablet:row-start-1 tablet:row-end-2 desktop:h-full',
              ),
              image: twMerge('mb-0 flex-1 w-fit aspect-[4/3] tablet:aspect-[3/4] desktop:aspect-[4/3]'), 
              contentContainer: 'p-[16px] flex-1', 
              title: twMerge('h5 line-clamp-4 tablet:line-clamp-2'), 
            }}
            thumbnail={post2.imageUrls.thumbUrl}
          />

            <Post 
               badge={{mobile: 'image', tablet: 'image', desktop: 'image'}}
            newsType={post3.newsType}
            targetSlug={data.targetSlug} 
            automated={data.automated} 
            targetType={data.targetType} 
            type={post3.type} 
            title={post3.title}

            image={{
              src: post3.imageUrls.url, 
              fill: true, 
              sizes: '100vw', 
              className: 'rounded-[12px] rounded-tl-[12px] rounded-tr-[12px] tablet:rounded-b-none aspect-[3/4] desktop:aspect-[4/3]',
              alt: post3.imageAlt || '', 
            }} 
            category={post3.category} 
            uniqueCode={post3.uniqueCode}
            hide={{category: true}}
            classNames={{
              wrapper: twMerge(
                'flex-1 flex-row tablet:flex-col rounded-[12px] tablet:col-start-4 tablet:col-end-5 tablet:row-start-1 tablet:row-end-2 desktop:h-full',
              ),
              image: twMerge('mb-0 flex-1 w-fit aspect-[4/3] tablet:aspect-[3/4] desktop:aspect-[4/3]'), 
              contentContainer: 'p-[16px] flex-1', 
              title: twMerge('h5 line-clamp-4 tablet:line-clamp-2'), 
            }}
            thumbnail={post3.imageUrls.thumbUrl}
          />

            <Post 
               badge={{mobile: 'image', tablet: 'inline', desktop: 'image'}}
            newsType={post4.newsType}
            targetSlug={data.targetSlug} 
            automated={data.automated} 
            targetType={data.targetType} 
            type={post4.type} 
            title={post4.title}
                        image={{
              src: post4.imageUrls.url, 
              fill: true, 
              sizes: '100vw', 
              className: 'block tablet:hidden desktop:block rounded-[12px] rounded-tl-[12px] rounded-tr-[12px] tablet:rounded-b-none aspect-[3/4] desktop:aspect-[4/3]',
              alt: post4.imageAlt || '', 
            }} 
            category={post4.category} 
            uniqueCode={post4.uniqueCode}
            hide={{category: true}}
            classNames={{
              wrapper: twMerge(
            'flex-1 flex-row tablet:flex-col rounded-[12px] tablet:col-start-3 tablet:col-end-4 tablet:row-start-2 tablet:row-end-3  desktop:h-full',
              ),
              image: twMerge('mb-0 block tablet:hidden desktop:block flex-1 w-fit aspect-[4/3] tablet:aspect-[3/4] desktop:aspect-[4/3]'), 
              contentContainer: 'p-[16px] flex-1', 
              title: twMerge('h5 line-clamp-4 tablet:line-clamp-2'), 
            }}
            thumbnail={post4.imageUrls.thumbUrl}
          />

            <Post 
               badge={{mobile: 'image', tablet: 'inline', desktop: 'image'}}
            newsType={post5.newsType}
            targetSlug={data.targetSlug} 
            automated={data.automated} 
            targetType={data.targetType} 
            type={post5.type} 
            title={post5.title}
            image={{
              src: post5.imageUrls.url, 
              fill: true, 
              sizes: '100vw', 
              className: 'block tablet:hidden desktop:block rounded-[12px] rounded-tl-[12px] rounded-tr-[12px] tablet:rounded-b-none aspect-[3/4] desktop:aspect-[4/3]',
              alt: post5.imageAlt || '', 
            }} 
            category={post5.category} 
            uniqueCode={post5.uniqueCode}
            hide={{category: true}}
            classNames={{
              wrapper: twMerge(
            'flex-1 flex-row tablet:flex-col rounded-[12px] tablet:col-start-4 tablet:col-end-5 tablet:row-start-2 tablet:row-end-3 desktop:h-full',
              ),
              image: twMerge('mb-0 block tablet:hidden desktop:block flex-1 w-fit aspect-[4/3] tablet:aspect-[3/4] desktop:aspect-[4/3]'), 
              contentContainer: 'p-[16px] flex-1', 
              title: twMerge('h5 line-clamp-4 tablet:line-clamp-2'), 
            }}
            thumbnail={post5.imageUrls.thumbUrl}
          />

       </div>
           <Link href={`/${data.targetSlug}`} className={twMerge('rounded-[6px] grid place-items-center w-fit px-[12px] h-[36px] cursor-pointer transition-all duration-300 hover:scale-[103%] self-end ml-[24px] desktop:ml-0 bg-gray-100 dark:bg-quaternary')}>
      <span className='text-dark dark:text-white h6'>المزيد</span>
    </Link>
      </section>
  )
}